<!-- @veltra/icons generated sha256:9a1d975dd790b811 gen:8 source:src/svg/colorful/title.svg -->
<script setup lang="ts">
defineOptions({ name: 'UTitle' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <rect width="10.5" height="10.5" x=".588" y="1" fill="#3670f7" rx="2" />
      <rect
        width="12.971"
        height="12.25"
        x="2.441"
        y="2.75"
        fill="#178fff"
        fill-opacity=".4"
        rx="2"
      />
      <rect
        width="12.971"
        height="12.25"
        x="2.441"
        y="2.75"
        fill="#f2f6ff"
        rx="2"
        style="mix-blend-mode: soft-light"
      />
    </g>
  </svg>
</template>
